import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export default function CustomPageLoading() {
  // const classes = useStyles();

  return (
    <Backdrop
      sx={{ zIndex: "99" }}
      // className={classes.backdrop}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
